<template>
  <svg :class="svgClass" aria-hidden="true" @click="clickEvent">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String || Object,
      default: '',
    },
    // click event
    onClick: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      let className = 'svg-icon'
      // className 支持object
      if (typeof this.className === 'string') {
        className += ` ${this.className}`
      } else if (typeof this.className === 'object') {
        className += ` `
        className += Object.keys(this.className)
          .filter((key) => this.className[key])
          .join(' ')
      }

      if (this.disabled) {
        className += ' disabled'
      }

      return className
    },
  },
  methods: {
    clickEvent() {
      this.$emit('onClick')
    },
  },
}
</script>

<style scoped>
.svg-icon {
  width: 18px;
  height: 18px;
  fill: currentColor;
  overflow: hidden;
  color: #9d9d9d;
  flex-shrink: 0;
}
</style>
<style>
.editor-menu-bar .svg-icon:hover {
  color: var(--iconHover);
}
</style>
